import { CircularProgress, Modal, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

const LoadingModal = ({ open, label, backgroundOpacity }) => {
  return (
    <Modal open={open}>
      <Box
        sx={{ height: "100vh" }}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-around"
          alignItems="center"
          sx={{
            width: "200px",
            height: "200px",
            backgroundColor: "black",
            borderRadius: 3,
            padding: 3,
            opacity: 0.75,
          }}
        >
          <CircularProgress my={2} size={75} />
          <Typography variant="h4" color="white" my={2}>
            {label}
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default LoadingModal;
